<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a>For Adele in 1977<br/>The best part<br/>For Adele still in 2007<a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?261f3dbd